import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function NotFound() {
  useDocumentTitle("404 Pagina non trovata");
  return (
    <section className="">
      <div className="py-8 px-4 mx-auto max-w-sm lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 text-5xl font-extrabold lg:text-9xl text-primary-600 dark:text-primary-500">
            Prenotazione non trovata
          </h1>
          <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
            Non siamo riusciti a trovare la prenotazione. Verifica che non sia
            scaduta o che il link sia ancora valido. Contatta la struttura per
            ulteriori informazioni.
          </p>
        </div>
      </div>
    </section>
  );
}
